import {UPDATE_BANNER_START} from "../../types";

export const update_banner = (payload) => ({
    type: UPDATE_BANNER_START,
    payload,
});
